import React from 'react';
import { Line } from 'react-chartjs-2';
import { useTheme } from '../../contexts/ThemeContext';
import { getChartJsOptions } from '../../utils/themeHelpers';

interface LineChartProps {
  data: any;
  options?: any;
  plugins?: any[];
  height?: number;
  title?: string;
  className?: string;
}

const LineChart: React.FC<LineChartProps> = ({
  data,
  options = {},
  plugins = [],
  height = 320,
  title,
  className = ''
}) => {
  const { currentTheme } = useTheme();

  const defaultOptions = getChartJsOptions(currentTheme);
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    maintainAspectRatio: false,
    responsive: true,
    elements: {
      ...(defaultOptions as any).elements,
      ...options?.elements,
      point: {
        ...(defaultOptions as any).elements?.point,
        ...options?.elements?.point,
        radius: 5, // Show dots on lines
        backgroundColor: 'white', // White center for better visibility
        borderWidth: 3, // Thicker border for the dots
        hoverRadius: 7, // Larger on hover
        hoverBorderWidth: 4,
      },
    },
  };

  return (
    <div className={`line-chart-container min-w-0 w-full ${className}`}>
      {title && (
        <h3 className="title-card">{title}</h3>
      )}
      <div
        className="relative min-w-0"
        style={{ height, width: '100%', position: 'relative' }}
      >
        <Line data={data} options={mergedOptions} plugins={plugins} />
      </div>
    </div>
  );
};

export default LineChart;